import { Injectable } from '@angular/core';
import { RelationsStore } from './relations.store';
import { switchMap, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ApiService } from '../../services/api/api.service';
import { RelationsQuery } from './relations.query';

@Injectable({providedIn: 'root'})
export class RelationsService {

  constructor(private relationsStore: RelationsStore,
              private apiService: ApiService,
              private relationsQuery: RelationsQuery,
  ) {
  }

  get() {
    const apiCall = this.apiService.get('configurations?filter[type]=RELATION').pipe(
      tap(data => {
        this.relationsStore.set(data['data']);
      })
    );
    const hasContents = this.relationsQuery.getCount();

    if (!hasContents) {
      return apiCall;
    } else {
      // This is cached for a day or something specified in the store.
      return this.relationsQuery.selectHasCache().pipe(
        switchMap(hasCache => {
          return (hasCache) ? EMPTY : apiCall;
        })
      );
    }
  }

  getRelationIdOfPartner() {
    return this.getRelationIdOf('Partner');
  }

  getRelationIdOf(relationName) {
    this.get().subscribe();
    const relations = this.relationsQuery.getAll();
    for (const relation of relations) {
      if (relation.name === relationName) {
        return relation.id;
      }
    }
  }
}
